import PropTypes from 'prop-types'
import { Row } from './Row'

export const TableBody = ({
  ids,
  getDataFromRedux,
  schema,
  isStickyFirstCol,
  onRowClick,
  onRightClick,
  selectedRowId,
  isSelectNotIn,
}) => {
  return (
    <tbody>
      {ids.map((id, rowIndex) => {
        return (
          <Row
            key={id}
            getDataFromRedux={getDataFromRedux}
            rowId={id}
            rowIndex={rowIndex}
            schema={schema}
            isStickyFirstCol={isStickyFirstCol}
            onRowClick={onRowClick}
            onRightClick={onRightClick}
            selectedRowId={selectedRowId}
            isSelectNotIn={isSelectNotIn}
          />
        )
      })}
    </tbody>
  )
}

TableBody.propTypes = {
  ids: PropTypes.array.isRequired,
  getDataFromRedux: PropTypes.func.isRequired,
  schema: PropTypes.array.isRequired,
  isStickyFirstCol: PropTypes.bool,
  onRowClick: PropTypes.func,
  selectedRowId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  onRightClick: PropTypes.func,
}

TableBody.defaultProps = {
  isStickyFirstCol: false,
  onRowClick: () => {},
}
